"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptionTermsSelector = void 0;

var subscriptionTermsSelector = function subscriptionTermsSelector(_ref) {
  var subscriptionTerms = _ref.subscriptionTerms;
  return subscriptionTerms;
};

exports.subscriptionTermsSelector = subscriptionTermsSelector;